<template>
  <div class="">
    <div v-if="checkChatAccess()">
      <div v-if="updateMode">
        <m-single-chat-wrapper ref="wrapper" @dataReady="dataReady" :slug="slug">
          <template v-slot="{chat,messages,pagination,current_page,usersInChat,chatUser,changePageFunction}">
            <div class="container ">
              <div class="row justify-content-center align-items-center">
                <div class="col-12 text-white rounded chat-info py-1">
                  <div class="row">
                    <div class=" my-2 col-12 text-center">{{ chat.subject }}</div>
                    <div class="col-6">
                      <div class=" chat-layout-button-wrapper d-inline-block m-2 ">
                        <div class="btn btn-secondary  rounded-pill">
                          <span class="bi bi-eye h5"></span>
                          {{ chat.status }}
                        </div>
                      </div>
                      <div class=" chat-layout-button-wrapper d-inline-block m-2 " dir="ltr">
                        <div class="btn btn-secondary rounded-pill"
                             :title="dateConverter(chat.created_at, '/', true, 'jalali')">
                          <span v-t="`chat.created_at`" class="mx-1"></span>
                          <span class="bi bi-calendar2-week h5"/>
                        </div>
                      </div>
                      <div class=" chat-layout-button-wrapper d-inline-block m-2 ">
                        <div class="btn btn-secondary d-inline-block  rounded-pill "
                             @click="removeCurrentChatData()">
                          <i class="bi bi-x-octagon-fill h5"></i>
                          <span v-t="`chat.finish_chat_message_button`" class="mx-2 "></span>
                        </div>
                      </div>
                      <div class=" chat-layout-button-wrapper d-inline-block m-2 ">
                        <div class="btn btn-secondary d-inline-block  rounded-pill " data-toggle="modal"
                             data-target="#send-sms">
                          <i class="bi bi-chat-left-fill h5"></i>
                          <span v-t="`chat.sms.form_button`" class="mx-2 "></span>
                        </div>
                      </div>
                    </div>
                    <div class=" my-2 col-6 mx-auto">
                      <UserInChat :userInChat="usersInChat"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal fade" id="send-sms" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="text-right" dir="rtl">
                      <notify-chat-users :chat="chat" :usersInChat="usersInChat"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="text-center">
              <div class="btn load-more-button px-5 my-4 " @click="loadMore()" v-t="`chat.load_more`"></div>
            </div>

            <div class="base-container" dir="ltr">
              <template v-for="message in messages">
                <div :id="`message-${message.id}`"
                     :class="[isMyMessage(chatUser, message) ? 'my-text-div' : 'friend-text-div']">
                  <div :class="[isMyMessage(chatUser, message) ? 'my-text-container' : 'friend-text-container']">
                    <div :class="[isMyMessage(chatUser, message) ? 'my-text' : 'friend-text']" dir="rtl">
                      <p class="user-info">{{ messengerName(message) }}</p>
                      <p>{{ message.message }}</p>

                      <m-a v-for="file in message.files" target="_blank" :href="file.file">
                        <i class="bi bi-file-earmark text-dark h4"></i>
                      </m-a>

                    </div>
                  </div>
                </div>
              </template>
            </div>

            <send-message @newMessage="newMessageHandler" :updateMode="true" :slug="slug" :wrapper-ref="wrapperRef"/>

          </template>
        </m-single-chat-wrapper>
      </div>
      <div v-else>

        <!--    show welcome message if set from user.    -->
        <div v-if="$t('chat.welcome_message').length > 0">
          <div id="message-welcome-message" class="p-2 m-1 bg-primary rounded">
            <div v-html="$t('chat.welcome_message')"></div>
          </div>
        </div>

        <send-message :chatUsers="chatUsers" class="fixed-bottom mb-2" @startNewChat="startNewChat"/>
      </div>
    </div>
    <div v-else class="text-center">
      <p v-t="`chat.authentication.message_for_un_authenticated_user`"></p>
      <m-a :href="{name:'Login'}">
        <div v-t="`chat.authentication.button_for_un_authenticated_user`" class="btn btn-primary"></div>
      </m-a>
    </div>
  </div>
</template>

<script>
import mSingleChatWrapper from "../../../Wrappers/SingleChatWrapper";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import SendMessage from "../../Component/SendMessage";
import mA from '../../../Tags/A'
import UserInChat from "../../Component/UserInChat.vue";
import NotifyChatUsers from "../../Component/NotifyChatUsers.vue";

export default {
  name: "ChatLayout",
  components: {NotifyChatUsers, UserInChat, SendMessage, mSingleChatWrapper, mA},
  data() {
    return {
      current_page: 1,
      last_page: 1,
      wrapperRef: null,
      showedMessages: [],
      getNewMessageMethod: null
    }
  },
  props: {
    slug: {
      default: null
    },
    chatUsers: {
      default: []
    }
  },
  computed: {
    updateMode() {
      return !(this.slug === null)
    }
  },
  methods: {
    dateConverter,
    newMessageHandler(message) {
      this.showedMessages.push(message.id)
    },
    isMyMessage(chatUser, message) {
      const chatUserId = chatUser.id
      const messageUserId = message.user.id
      return chatUserId === messageUserId
    },
    scrollToElement() {
      const findLastMessageId = this.wrapperRef.last_message.id
      document.getElementById(`message-${findLastMessageId}`).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      })
    },
    dataReady(response) {
      this.last_page = response.meta.last_page
      this.scrollToElement()
      const messages = response.data
      this.setShowedMessages(messages)
    },
    loadMore() {
      if (this.current_page < this.last_page) {
        this.current_page += 1
        this.wrapperRef.changePage(this.current_page)
        this.scrollToElement()
      }
    },
    setShowedMessages(messages) {
      messages.forEach(item => {
        this.showedMessages.push(item.id)
      })
    },
    async showNewMessages() {
      const chatToken = localStorage.getItem('chat_token');
      const form = {page: 1, slug: this.wrapperRef.slug, chat_token: chatToken, withoutState: true}
      let res = await this.$store.dispatch('Chat/getSingleChat', form)
      const data = res.data.data;
      const messages = data.data

      let newMessage = []

      messages.forEach(item => {
        const itemId = item.id;
        if (this.showedMessages.indexOf(itemId) === -1) {
          this.showedMessages.push(itemId)
          newMessage.push(itemId)
          this.wrapperRef.addMessages([item], true)
        }
      })

      if (newMessage.length > 0) {

        document.querySelector(`.send-message-container`).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        })

      }


      return newMessage

    },
    startNewChat(value) {
      this.$emit('startNewChat', value)
    },
    removeCurrentChatData() {
      if (confirm(this.$t('chat.finish_chat_message'))) {
        localStorage.removeItem('chat_token')
        localStorage.removeItem('chat_slug')
        window.location.reload()
      }
    },
    checkChatAccess() {
      const isAuth = this.$store.getters['User/isAuthenticated']
      const chat_access = this.findAttributeOnSiteInfo('chat_access')[0] == 1;
      if (chat_access) {
        return isAuth
      }
      return true
    },
    messengerName(message) {
      let user = message.user
      if (Object.keys(user).indexOf('public_name') > -1 && user.public_name != null && user.public_name.length > 0) {
        return user.public_name
      }
      return `${user.name} ${user.last_name}`
    }
  },
  mounted() {
    this.wrapperRef = this.$refs['wrapper']

    if (this.updateMode) {
      this.getNewMessageMethod = setInterval(() => {
        this.showNewMessages()
      }, 35_000)
    }

  },
  unmounted() {
    if (this.updateMode) {
      clearInterval(this.getNewMessageMethod);
    }
  },
  updated() {
    if (this.updateMode) {
      this.getNewMessageMethod = setInterval(() => {
        this.showNewMessages()
      }, 35_000)
    }
    this.wrapperRef = this.$refs['wrapper']
  }
}
</script>

<style scoped>
.base-container {
  width: 100%;
}

.friend-text-div {
  display: flex;
  margin-left: 0.5rem;
}

.friend-text-div > i {
  height: 2rem;
  font-size: 25px;
  align-self: flex-end;
}

.friend-text-container {
  width: 75%;
  display: flex;
  flex-direction: column;
}

.my-text-container, .friend-text-container {
  margin: 8px 0;
}


.friend-text {
  background: var(--secondary);
  border-radius: 0.5rem;
  color: #fff;
  height: fit-content;
  width: fit-content;
  padding: 0.5rem 1rem;
  margin: 0.12rem 0.5rem;
}

.my-text-div {
  display: flex;
  justify-content: flex-end;
}

.my-text-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.my-text {
  background: linear-gradient(
      180deg,
      var(--primary) 0%,
      var(--primary) 51%,
      var(--secondary) 92%
  ) no-repeat center;
  background-attachment: fixed;
  color: #fff;
  border-radius: 0.5rem 0.2rem 0.2rem 0.5rem;
  height: fit-content;
  width: fit-content;
  padding: 0.5rem 1rem;
  margin: 0.12rem 0.5rem;
}

.my-text-container > div:first-child {
  border-radius: 0.5rem 1rem 0.2rem 0.5rem;
}

.my-text-container > div:last-child {
  border-radius: 0.5rem 0.2rem 1rem 0.5rem;
  width: 75%;
}

.friend-text-container > div:first-child {
  border-radius: 1rem 0.5rem 0.2rem 0.5rem;
}

.friend-text-container > div:last-child {
  border-radius: 0.5rem 0.2rem 0.5rem 1rem;
}

.user-info {
  font-size: 12px;
}

.chat-info {
  background: var(--primary);
}


.load-more-button {
  background-color: var(--secondary);
}

.chat-layout-button-wrapper * {
  font-size: 13px;
}

</style>